import { render, staticRenderFns } from "./PlanNameColumn.vue?vue&type=template&id=0b571884&"
import script from "./PlanNameColumn.vue?vue&type=script&lang=js&"
export * from "./PlanNameColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports